import { useEffect, useState } from 'react';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { SecondScreenHost } from './SecondScreen';
import './newExperiences.css';
const NativePiP=registerPlugin('HedonePiP');

export default function PlayerExtras({item,playerRef}){
  const [mini,setMini]=useState(false),[pair,setPair]=useState(false),[notice,setNotice]=useState('');
  const [toolsOpen,setToolsOpen]=useState(false);
  const [pipPending,setPipPending]=useState(false);
  useEffect(()=>{
    const player=playerRef.current;
    player?.classList.toggle('is-mini-player',mini);
    document.body.classList.toggle('player-mini-active',mini);
    return()=>{player?.classList.remove('is-mini-player');document.body.classList.remove('player-mini-active');};
  },[mini,playerRef]);
  useEffect(()=>{
    const change=event=>document.body.classList.toggle('native-pip',!!(event.detail?.active ?? event.active));
    window.addEventListener('hedonePipChanged',change);
    return()=>{window.removeEventListener('hedonePipChanged',change);document.body.classList.remove('native-pip');};
  },[]);
  const toggleMini=async()=>{setNotice('');setToolsOpen(false);if(document.fullscreenElement){try{await document.exitFullscreen();}catch{setNotice('Exit full screen first to use the mini-player.');return;}}setMini(v=>!v);};
  const pip=async()=>{
    if(pipPending)return;
    try{
      if(Capacitor.getPlatform()==='android'){
        setPipPending(true);setToolsOpen(false);setNotice('');
        document.body.classList.add('native-pip');
        // Paint the clean video surface before Android captures the PiP transition.
        await new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(resolve)));
        await NativePiP.enter();return;
      }
      const video=playerRef.current?.querySelector('video');
      if(video && document.pictureInPictureEnabled && video.requestPictureInPicture){if(document.pictureInPictureElement)await document.exitPictureInPicture();else await video.requestPictureInPicture();setNotice('');return;}
      if(video?.webkitSupportsPresentationMode?.('picture-in-picture')){video.webkitSetPresentationMode('picture-in-picture');setNotice('');return;}
      setNotice('This embedded source controls browser PiP. Use its PiP button if available, or Mini-player to keep watching within this page.');
    }catch{document.body.classList.remove('native-pip');setNotice('Picture-in-picture is unavailable. Try the Mini-player, or enable PiP permission for Hedone in Android settings.');}
    finally{setPipPending(false);}
  };
  return <>
    <div className="player-extra-actions">
      <button className="player-tools-toggle" aria-label="Player tools" aria-expanded={toolsOpen} onClick={()=>setToolsOpen(value=>!value)}>•••</button>
      {mini&&<button className="mini-restore" onClick={toggleMini}>Restore player</button>}
      {toolsOpen&&<div className="player-tools-menu" aria-label="Player tools menu">
        <button disabled={pipPending} onClick={pip}>Picture-in-picture</button>
        <button onClick={()=>{setToolsOpen(false);toggleMini();}}>{mini?'Restore player':'Mini-player'}</button>
        {!mini&&<button onClick={()=>{setToolsOpen(false);setPair(value=>!value);}}>Second screen</button>}
        <button onClick={()=>setToolsOpen(false)}>Back to video / subtitles</button>
      </div>}
    </div>
    {notice&&<div className="player-extra-notice" role="status">{notice}<button aria-label="Dismiss player notice" onClick={()=>setNotice('')}>×</button></div>}
    <SecondScreenHost item={item} playerRef={playerRef} visible={pair && !mini} onClose={()=>setPair(false)}/>
  </>;
}
